import { useRef } from 'react';
import { useSelector } from 'react-redux';
import { Box, Flex, HStack, Text } from '@chakra-ui/react';
import { ArrowBackIcon, CheckCircleIcon, DownloadIcon } from '@chakra-ui/icons';
import { Button, Heading } from '@/components/v4';
import AGGridMain from '@/components/tables/AGGrid/AGGridMain';

export default function APIResultsView(props) {
    const {
        error,
        succeed,
        handleExportFailedData,
        handleDone,
        succeedAPIColumns,
        failedAPIColumns,
    } = props;
    const { currentCompanyData } = useSelector(
        (state) => state.navigationLists,
    );
    const companyName = currentCompanyData?.name ?? 'your company';

    const gridRef = useRef();
    const succeedData = succeed.map((res) => res.data);
    const hasSucceed = succeedData.length > 0;
    const hasFailed = error.length > 0;
    const noChanges = !hasSucceed && !hasFailed;

    return (
        <Box display="block">
            <Flex direction="column" alignItems="center" py={8} mb={6}>
                <CheckCircleIcon
                    boxSize={16}
                    color={noChanges ? 'blue.400' : 'green.400'}
                    mb={4}
                />
                <Heading size="xl" textAlign="center" mb={2}>
                    {noChanges ? 'No changes detected' : 'Import successful'}
                </Heading>
                <Text color="gray.500" fontSize="sm" textAlign="center">
                    {noChanges
                        ? `No differences found for ${companyName}.`
                        : `Processed for ${companyName}.`}
                </Text>
            </Flex>

            {hasSucceed && (
                <Box mb={6}>
                    <HStack justifyContent="space-between" mb={3}>
                        <Text fontWeight="semibold" fontSize="md">
                            Summary of changes
                        </Text>
                        <Button
                            size="sm"
                            leftIcon={<DownloadIcon />}
                            onClick={handleExportFailedData}>
                            Export Results
                        </Button>
                    </HStack>
                    <AGGridMain
                        gridRef={gridRef}
                        isLoading={false}
                        refetch={null}
                        stateIdentifier="planCsvApiSucceeded"
                        overlayNoRowsTemplate="No results"
                        tableData={{
                            columns: succeedAPIColumns,
                            data: succeedData,
                        }}
                        suppressMenuHide={false}
                        getQuickFilterText={null}
                        columnDefs={succeedAPIColumns}
                    />
                </Box>
            )}

            {hasFailed && (
                <Box mb={6}>
                    <HStack justifyContent="space-between" mb={3}>
                        <Text
                            fontWeight="semibold"
                            fontSize="md"
                            color="red.600">
                            Failed ({error.length})
                        </Text>
                        {!hasSucceed && (
                            <Button
                                size="sm"
                                leftIcon={<DownloadIcon />}
                                onClick={handleExportFailedData}>
                                Export Results
                            </Button>
                        )}
                    </HStack>
                    <AGGridMain
                        gridRef={gridRef}
                        isLoading={false}
                        refetch={null}
                        stateIdentifier="planCsvApiFailed"
                        overlayNoRowsTemplate="No failed records"
                        tableData={{ columns: failedAPIColumns, data: error }}
                        suppressMenuHide={false}
                        getQuickFilterText={null}
                        columnDefs={failedAPIColumns}
                    />
                </Box>
            )}

            <HStack spacing={3} mt={4}>
                <Button
                    leftIcon={<ArrowBackIcon />}
                    variant="outline"
                    onClick={handleDone}>
                    Upload another file
                </Button>
                {noChanges && (
                    <Button
                        leftIcon={<DownloadIcon />}
                        onClick={handleExportFailedData}>
                        Export Results
                    </Button>
                )}
            </HStack>
        </Box>
    );
}
